import axiosInst from '../../libs/axios/axios'
const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  timeOut: process.env.VUE_APP_TIME_OUT,
  userData: {}
}
const getters = {
  returnUserData (state) {
    return state.userData
  }
}
const mutations = {
  userData (state, info) {
    state.userData = info
  }
}
const actions = {
  getUserList (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/user/tenant/${  info}`).then(response => {
        const userData = []
        if (response.data.results.length) {
          response.data.results.map((value) => {
            userData.push({
              'email': value.email,
              'role': value.is_account_manager,
              'id': value.id,
              'company': value.company,
              'first_name': value.first_name,
              'last_name': value.last_name,
              'phone': value.phone
            })
          })
          store.commit('userData', userData)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  createAdminUser (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.post(`${state.rootUrl  }/api/user/tenant/`, data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteUser (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.delete(`${state.rootUrl  }/api/user/tenant/${  data.id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getUserAndCompanyList () {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/user/tenant/related_users/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async getDeviceManagement (store, info) {
    try {
      const response = await axiosInst.get(info === null ? `${state.rootUrl  }/api/device/management/` : info)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async getUserSelectBoxData () {
    try {
      const response = await axiosInst.get(`${state.rootUrl  }/api/user/tenant/related_users/`)
      const userAndCompanyOptions = []
      if (response.data) {
        response.data.map((value) => {
          let name = null
          if (value.company && !value.first_name) {
            name = value.company
          }
          if (value.first_name && !value.company) {
            name = `${value.first_name  } ${  value.last_name}`
          }

          if (value.first_name && value.company) {
            name = `${value.first_name  } ${  value.last_name  } (${  value.company  })`
          }

          userAndCompanyOptions.push({
            value: value.id,
            label: name
          })
        })
      }

      return Promise.resolve(userAndCompanyOptions)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async getDeviceManagementData (store, info) {
    try {
      const response = await axiosInst.get(`${state.rootUrl  }/api/device/${  info  }/management/rental-info`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async editDeviceManagementData (store, info) {
    try {
      const response = await axiosInst.patch(`${state.rootUrl  }/api/device/${  info.id}/`, info.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async deleteDeviceManagementRental (store, info) {
    try {
      const response = await axiosInst.delete(`${state.rootUrl  }/api/device/management/rental/${  info}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async extendRental (store, info) {
    try {
      const response = await axiosInst.put(`${state.rootUrl  }/api/device/management/rental/${  info.id}`, info.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async getAutoFillDevice (store, info) {
    try {
      const response = await axiosInst.get(`${state.rootUrl  }/api/rental/device/${  info}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async getSearchRentalDevice (store, info) {
    try {
      const response = await axiosInst.get(`${state.rootUrl  }/api/rental/device/${  info}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async createRentalDevice (store, info) {
    try {
      const response = await axiosInst.post(`${state.rootUrl  }/api/rental/`, info)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
    
  getUserRental (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/user/rental/${  info}`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
